var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hero-section"
  }, [_vm._m(0), _c('div', {
    staticClass: "home-reg"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "reg-desc"
  }, [_c('div', {}, [_vm._m(1), _c('div', [_c('button', {
    staticClass: "com-reg btn-submit",
    on: {
      "click": function click($event) {
        return _vm.clickHandler('business');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/company.svg")
    }
  }), _vm._v("Company ")]), _c('button', {
    staticClass: "personal-reg btn-submit",
    on: {
      "click": function click($event) {
        return _vm.clickHandler('individual');
      }
    }
  }, [_c('img', {
    staticClass: "me-2",
    attrs: {
      "src": require("@/assets/images/personal.svg")
    }
  }), _vm._v("Individual ")])])]), _c('div', {
    staticClass: "mt-3 error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))])]), _c('div', {
    staticClass: "text-center"
  }, [_vm._m(2), _c('button', {
    staticClass: "personal-reg btn-submit mt-0 mb-5",
    on: {
      "click": function click($event) {
        _vm.showVideoModal = true;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-eye me-2"
  }), _vm._v(" Watch Video ")])]), _c('div', {
    staticClass: "contact-details mb-3 pb-1"
  }, [_vm.info ? _c('div', {
    staticClass: "d-flex gap-2"
  }, [_c('h6', {
    staticClass: "mb-0"
  }, [_c('i', {
    staticClass: "fas fa-address-card me-2 contact-icon"
  }), _vm._v("Direct Contact: " + _vm._s(_vm.info.first_name) + " " + _vm._s(_vm.info.last_name) + " ")]), _c('div', {
    staticClass: "bottom-line"
  })]) : _vm._e(), _vm.info ? _c('div', {
    staticClass: "d-flex gap-2"
  }, [_c('h6', {
    staticClass: "mb-0"
  }, [_c('i', {
    staticClass: "fas fa-envelope me-2 email-icon"
  }), _vm._v("Email: "), _c('a', {
    attrs: {
      "href": "mailto:".concat(_vm.info.email)
    }
  }, [_vm._v(_vm._s(_vm.info.email))])]), _c('div', {
    staticClass: "bottom-line"
  })]) : _vm._e(), _vm.info ? _c('div', {}, [_c('h6', {
    staticClass: "mb-0"
  }, [_c('i', {
    staticClass: "fas fa-phone me-4 mb-2 pb-1 phone-icon"
  }), _vm._v("Phone: "), _c('a', {
    attrs: {
      "href": "tel:".concat(_vm.info.phone)
    }
  }, [_vm._v(_vm._s(_vm.info.phone))])])]) : _vm._e()]), _c('p', {
    staticClass: "note"
  }, [_vm._v(" Please note that after registration "), _vm.info ? _c('span', [_vm._v(" " + _vm._s(_vm.info.first_name) + " " + _vm._s(_vm.info.last_name) + " ")]) : _vm._e(), _vm._v(" , will contact you by phone for a quick conversation, then as soon as you activate you can start selling right away. ")])])]), _c('b-modal', {
    staticClass: "p-0",
    attrs: {
      "id": "video-modal-show",
      "centered": "",
      "size": "lg",
      "hide-footer": "",
      "hide-header": ""
    },
    on: {
      "hide": _vm.pauseVideo
    },
    model: {
      value: _vm.showVideoModal,
      callback: function callback($$v) {
        _vm.showVideoModal = $$v;
      },
      expression: "showVideoModal"
    }
  }, [_c('div', {}, [_c('span', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("×")])]), _c('video', {
    ref: "videoModal",
    attrs: {
      "width": "100%",
      "controls": "",
      "autoplay": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.videoLink,
      "type": "video/mp4"
    }
  })])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "home-page-txt"
  }, [_c('h4', [_vm._v("Over 30 years of building relationships. ")]), _c('h5', [_vm._v("One broker at a time.")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h4', {
    staticClass: "broker-rep mt-4 pt-2"
  }, [_c('b', [_vm._v("Select Registration Type")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h4', {
    staticClass: "hight-light mb-3 mt-5"
  }, [_c('b', [_vm._v("Watch Video about NuEra Benefits")])]);
}]

export { render, staticRenderFns }